export const productVariantStatusLabelTestIds = {
    status: 'ProductVariantStatusLabel.Status',
} as const;
